import * as classNames from 'classnames';
import * as React from 'react';
import * as PropTypes from 'prop-types';

import S from './input-form-text.module.scss';

const InputFormText = ({
  id,
  name,
  value,
  type = text,
  hasError,
  isDisabled,
  placeholder,
  handleFocus,
  handleBlur,
  handleChange,
}) => {
  return (
    <input
      id={id}
      name={name}
      placeholder={placeholder}
      className={classNames(S.textFormInput, { [S.error]: hasError })}
      type={type}
      disabled={isDisabled}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      value={value}
    />
  );
};

InputFormText.displayName = 'InputFormText';

InputFormText.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  handleFocus: PropTypes.func,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
};

InputFormText.defaultProps = {
  id: null,
  type: 'text',
  placeholder: null,
  handleBlur: null,
  handleFocus: null,
};

export { InputFormText };
